import { Button, DialogContent, Typography } from '@material-ui/core';
import { StyledDialog } from '@room-match/shared-ui-components';
import { useEffect, useState } from 'react';
import { useStyles } from './MissingInfoDialog.styles';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { talentService } from 'shared/services/talentService';
import { ls } from 'shared/utils/ls';
import { useAppSelector } from 'shared/redux/store';
import { ISpecificTalentResponsePayload } from 'shared/interfaces/ITalent';
import { COLORS } from 'shared/constants/COLORS';

const MissingInfoDialog: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState<boolean>(false);
  const [talent, setTalent] = useState<ISpecificTalentResponsePayload['data']['talent']>();
  const { getMyData } = talentService();

  const { getLS } = ls();
  const user = JSON.parse(getLS('user') || '{}');
  const { user: userState } = useAppSelector((state) => state);
  const userData = userState?.user || user;

  const { data: myData, isLoading: myDataLoading } = getMyData(userData.id);

  // REMOVE FOR NOW WORK STILL IN PROGRESS
  // useEffect(() => {
  //   if (!myDataLoading && myData && myData.data) {
  //     const { talent: talentData } = myData.data;
  //     setTalent(talentData);
  //     const genderMissing = !talentData.gender || talentData.gender === '';
  //     const ethnicityMissing =
  //       !talentData?.general?.ethnic_appearance_primary || talentData?.general?.ethnic_appearance_primary === '';
  //     const heightMissing = !talentData?.statistics?.height || talentData?.statistics?.height === '';
  //     const weightMissing = !talentData?.statistics?.weight || talentData?.statistics?.weight === '';
  //     const ageRangeMissing = !(userData?.attributes?.age_range_from && userData?.attributes?.age_range_to);

  //     if (genderMissing || ethnicityMissing || heightMissing || weightMissing || ageRangeMissing) {
  //       setOpen(true);
  //     }
  //   }
  // }, [myData, myDataLoading]);

  return (
    <StyledDialog classes={{ paper: classes.paper }} open={open} maxWidth="md" fullWidth>
      <DialogContent className={classes.dialogContent}>
        <Typography style={{ fontSize: 18, marginBottom: 20 }}>
          Your profile is missing critical information regarding your ability to be submitted by your representative or
          to be chosen by a Casting Director. You could be missing auditions based on this missing information.
        </Typography>
        <Typography style={{ fontSize: 18 }}>
          Please ensure the following information is accurate and up to date:
        </Typography>
        <div className={classes.missingInfos}>
          <Typography className={`${classes.infoDetails} ${!talent?.gender && 'missing'}`}>
            Gender: {talent?.gender || 'Missing Information'}
          </Typography>
          <Typography className={`${classes.infoDetails} ${!talent?.general?.ethnic_appearance_primary && 'missing'}`}>
            Ethnicity: {talent?.general?.ethnic_appearance_primary || 'Missing Information'}
          </Typography>
          <Typography className={`${classes.infoDetails} ${!talent?.statistics?.height && 'missing'}`}>
            Height: {talent?.statistics?.height || 'Missing Information'}
          </Typography>
          <Typography className={`${classes.infoDetails} ${!talent?.statistics?.weight && 'missing'}`}>
            Weight: {talent?.statistics?.weight || 'Missing Information'}
          </Typography>
          <Typography
            className={`${classes.infoDetails} ${!(userData?.attributes?.age_range_from && userData?.attributes?.age_range_to) && 'missing'}`}
          >
            Age Range:{' '}
            {userData?.attributes?.age_range_from && userData?.attributes?.age_range_to
              ? `${userData?.attributes?.age_range_from} to ${userData?.attributes?.age_range_to}`
              : 'Missing Information'}
          </Typography>
        </div>
        <div className={classes.buttonContainer}>
          <Button
            type="button"
            variant="contained"
            color="primary"
            disableElevation
            className={classes.updateBtn}
            onClick={() => history.push(ROUTES.TALENT.MYINFO + '/general_appearance')}
          >
            Click here to update "My Info"
          </Button>
        </div>
      </DialogContent>
    </StyledDialog>
  );
};

export default MissingInfoDialog;
